import { twMerge } from "tailwind-merge";
import { useEffect, useRef, useState } from "react";

import Label from "@/components/form-controls/Label";
import Human from "@/assets/images/human.webp";



export type AvatarInputProps = {
    name?: string
    className?: string
    label?: string,
    labelStyle?: string,
    hasError?: boolean
    error? : string,
    onChange: (value: FileList) => void;
    required?: boolean
}


const AvatarInput = (props: AvatarInputProps) => {
    const ref = useRef(null);
    const [files, setFiles] = useState<FileList | null>(null);

    useEffect(() => {
        if(files) {
            props.onChange(files);
        }
    }, [files])

    return (
        <div className={props.className}>
            <Label 
                name={props.name ?? ""} 
                text={props.label} 
                required={props.required}
                className={props.labelStyle}
            />

            <div>
                <label 
                    htmlFor={props.label} 
                    onClick={() => ref.current}
                    className={twMerge(
                        "relative block w-24 h-24 border border-dashed cursor-pointer rounded-full overflow-hidden",
                        props.hasError ? "border-rose-800 bg-rose-50" : "border-zinc-200 bg-zinc-50",
                    )}
                >
                    <input
                        type="file"
                        className="hidden"
                        id={props.label}
                        ref={ref}
                        multiple={false}
                        onChange={(event) => setFiles(event.target.files)}
                    />

                    <div className="absolute inset-0 flex flex-col justify-center items-center text-primary">
                        <img src={Human} className="w-12 h-12 rounded-full" />
                    </div>

                    {
                        files &&
                        Object.keys(files).map((fileName, index) => {
                            let file = files[index];
                            let isImageFile = file.type.split("/")[0] === "image";

                            return (
                                <section 
                                    className={twMerge(
                                        "absolute z-20 inset-0 w-full text-zinc-500 bg-zinc-50 border border-zinc-100 rounded-lg overflow-hidden"
                                    )} 
                                    key={fileName}
                                >
                                    
                                    {
                                        isImageFile &&
                                        <img
                                            src={URL.createObjectURL(file)}
                                            alt={`file preview ${index}`}
                                            className="w-full h-full object-cover object-center"
                                        /> 
                                    }
                                    
                                </section>
                            );
                        }) 
                    }
                </label>

                <p className="text-[10px] text-zinc-500 pt-2">
                    max size: 2MB
                </p>
            </div>

            {
                props.hasError &&
                <div className="text-xs text-rose-800 font-medium px-1 pt-1">
                    {
                        props.error ?
                        props.error :
                        "field is required"
                    }
                </div>
            }
            
        </div>
    )
}

export default AvatarInput